import { useContext } from 'react';

import { OmeMeetEntryInfoStateContext } from './OmeMeetEntryInfoContextProvider';
import OmeMeetEntryInfoData from './OmeMeetEntryInfoData';

const useOmeMeetEntryInfoData = () => {
  const [omeMeetEntryInfoState, setOmeMeetEntryInfoState] = useContext(OmeMeetEntryInfoStateContext);

  const getOmeMeetEntryInfoByOmeMeetId = (omeMeetId, isCurrent) => OmeMeetEntryInfoData.getOmeMeetEntryInfoByOmeMeetIdData(omeMeetId, isCurrent, omeMeetEntryInfoState, setOmeMeetEntryInfoState);

  return {
    omeMeetEntryInfoState,
    getOmeMeetEntryInfoByOmeMeetId
  };
};

export default useOmeMeetEntryInfoData;